import React, { useEffect, useState } from "react";
import { useLocation, BrowserRouter } from "react-router-dom"; // Importe useLocation e BrowserRouter
import Routes from "./routes";
import GlobalStyles, { Layout, Main } from "./styles/global";
import { ScreenClassProvider } from "react-grid-system";
import ReactNotification from "react-notifications-component";
import Navbar from "../src/components/navbar";
import BlackNovember from "../src/components/countdown-black-system/index";
import TopBanner from "../src/components/top-banner/index";
import { logged } from "./services/auth";
import { CultureProvider } from './contexts/CultureContext';
import { HeaderMenuProvider } from './contexts/HeaderMenuContext';
import api from "./services/api";
import ImpersonationBanner from "./components/impersonation-banner";

export const USER = "@userinfo";

const MainApp = () => {
  const [isFull, setIsFull] = useState(false);
  const [closeAllTabs, setCloseAllTabs] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [routeConfig, setRouteConfig] = useState([]);
  const [isOpen, setIsOpen] = useState(true);
  const [isBlackNovemberVisible, setIsBlackNovemberVisible] = useState(false);
  const [blackNovember, setBlackNovember] = useState(false)
  const [statusLogged, setStatusLogged] = useState(localStorage.getItem("@logged"))
  const [campaigns, setCampaigns] = useState(null);
  const [topBannerAlerta, setTopBannerAlerta] = useState(null);

  const currentDate = new Date();
  const location = useLocation();
  const isOpenAppRoute = location.pathname === "/abrir-app";

  if (window.ReactNativeWebView) {
    localStorage.setItem("@agroreceita:source", "app");
  }
  
  const getCampaign = async () => {
    try {
      const response = await api.get("/campaigns");
      const data = Array.isArray(response.data?.data)
        ? response.data.data
        : Array.isArray(response.data)
          ? response.data
          : [];
      const activeCampaign = data.length > 0 ? data[0] : null;
      setCampaigns(activeCampaign);
      const isLogged = localStorage.getItem("@logged");
      setBlackNovember(!!isLogged && !!activeCampaign);
    } catch (err) {
      setCampaigns(null);
      setBlackNovember(false);
    }
  }

  const getAlertas = async () => {
    const isLogged = localStorage.getItem("@logged");
    if (!isLogged) return;
    try {
      const response = await api.get("/alertas");
      const alertas = response.data?.data ?? [];
      setTopBannerAlerta(alertas.length > 0 ? alertas[0] : null);
    } catch {
      setTopBannerAlerta(null);
    }
  }

  useEffect(() => {
    if (isOpenAppRoute) return;

    getCampaign();
    const interval = setInterval(getCampaign, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, [isOpenAppRoute]);

  useEffect(() => {
    if (isOpenAppRoute) return;

    getAlertas();
    const interval = setInterval(getAlertas, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, [isOpenAppRoute]);

  const targetDate = new Date('2025-11-30T23:59:59');

  const userPlan = localStorage.getItem('@plan_name');

  const checkRouteInAllowedRoutes = () => {
    const storedRoutes = localStorage.getItem('allowedRoutes');

    if (storedRoutes) {
      const allowedRoutes = JSON.parse(storedRoutes);

      const currentPath = location.pathname;

      if (allowedRoutes.includes(currentPath)) {
        setIsBlackNovemberVisible(true);
      } else {
        setIsBlackNovemberVisible(false);
      }
      
    }
  };

  const handleBlackNovemberVisibility = (isVisible) => {
    setIsBlackNovemberVisible(isVisible);

    const campaignTargetDate = campaigns?.data_final ? new Date(campaigns.data_final) : new Date(0);

    if (currentDate > campaignTargetDate || 
      userPlan === "PLANO PRO" || 
      userPlan === "PLANO LIGHT" || 
      userPlan === "PLANO BASIC" || 
      userPlan === "PLANO PRÉ-PAGO") {
      setIsBlackNovemberVisible(!isVisible);
    }

    if (currentDate > campaignTargetDate || userPlan !== "TESTE GRÁTIS") {
      setIsBlackNovemberVisible(!isVisible);
    }
  };

  const closeAllTabsFromNavBar = () => {
    setCloseAllTabs(true);
  };

  useEffect(() => {
    const isLogged = localStorage.getItem("@logged");

    if (isLogged) {
      setStatusLogged(true);
      setBlackNovember(!!campaigns);
    } else {
      setStatusLogged(false);
      setBlackNovember(false);
    }

    // Sem campanha (desativada/expirada), o <BlackNovember> nem chega a montar —
    // e sem montar, ele nunca chama onVisibilityChange pra avisar que sumiu.
    // isBlackNovemberVisible ficava preso no último valor (geralmente true),
    // e o Navbar (hasPromo) continuava empurrando o header pra baixo mesmo sem
    // banner nenhum na tela.
    if (!isLogged || !campaigns) {
      setIsBlackNovemberVisible(false);
    }
  }, [statusLogged, campaigns]);

  useEffect(() => {
    if (isOpenAppRoute) return;

    checkRouteInAllowedRoutes();
  }, [isOpenAppRoute, location.pathname]); 

  if (isOpenAppRoute) {
    return (
      <Layout>
        <Main isFull={true} isOpen={false}>
          <Routes
            isMobile={isMobile}
            isOpen={false}
            upConfig={(e) => setRouteConfig(e)}
            campaigns={campaigns}
          />
        </Main>
      </Layout>
    );
  }

  return (
    <Layout>
      <Navbar
        updateIsFullScreen={(e) => setIsFull(e)}
        isOpen={(e) => setIsOpen(e)}
        closeAllTabs={closeAllTabs}
        isClosed={() => setCloseAllTabs(!closeAllTabs)}
        updateIsMobile={(e) => setIsMobile(e)}
        routeConfig={routeConfig}
        isBlackNovember={isBlackNovemberVisible}
        hasTopBanner={!!topBannerAlerta}
      />
      <Main
        isFull={isFull}
        isOpen={isOpen}
        onClick={() => closeAllTabsFromNavBar()}
        isLoggedUser={statusLogged}
      >
        <ImpersonationBanner />

        <TopBanner alerta={topBannerAlerta} onClose={() => setTopBannerAlerta(null)} />

        { blackNovember && campaigns ? (
          <BlackNovember onVisibilityChange={handleBlackNovemberVisibility} campaign={campaigns} />
        ) : (<></>)}

        <Routes
          isMobile={isMobile}
          isOpen={isOpen}
          upConfig={(e) => setRouteConfig(e)}
          campaigns={campaigns}
        />
      </Main>
    </Layout>
  );
};

const App = () => {
  return (
    <CultureProvider>
      <HeaderMenuProvider>
        <ScreenClassProvider>
          <ReactNotification />

          <GlobalStyles />

          <BrowserRouter>
            <MainApp />
          </BrowserRouter>
        </ScreenClassProvider>
      </HeaderMenuProvider>
    </CultureProvider>
  );
};

export default App;
